<template>
  <div class="ps-table-wrap">
    <ve-table
      :fixed-header="true"
      :columns="columns"
      :table-data="tableData"
      :border-around="false"
      :sort-option="sortOption"
      :max-height="'calc(100vh - 210px)'"
    />
    <empty-state v-if="!isLoading && showEmptyResult" :title="'No record found!'" />
    <div v-if="isLoading" class="campaign--loader">
      <spinner />
      <span>{{ $t('COUPON.COUPON_LIST.LOADING') }}</span>
    </div>

  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import moment from 'moment';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import WootButton from 'dashboard/components/ui/WootButton.vue';
import Label from 'dashboard/components/ui/Label';
import {SYSTEM_TOOL_IDS,TOOL_KIND_STRING} from "../ai.constant"

// const systemDemoData = [
//   {
//     id: SYSTEM_TOOL_IDS.END_CALL,
//     name: SYSTEM_TOOL_IDS.END_CALL,
//     description: "system tool 1",
//     global: false,
//     llm_chatbot_id: 40000,
//     account_id: 613,
//     kind: TOOL_KIND_STRING.PRECONFIGURE,
//     extras: null,
//     created_at: "2025-08-25T04:31:20.921Z",
//     updated_at: "2025-08-25T06:04:09.401Z",
//     editable: false
//   },
//   {
//     id: SYSTEM_TOOL_IDS.TRANSFER_TO_AGENT,
//     name: SYSTEM_TOOL_IDS.TRANSFER_TO_AGENT,
//     description: "system tool 2",
//     global: false,
//     llm_chatbot_id: 40001,
//     account_id: 613,
//     kind: TOOL_KIND_STRING.PRECONFIGURE,
//     extras: null,
//     created_at: "2025-08-25T04:31:20.921Z",
//     updated_at: "2025-08-25T06:04:09.401Z",
//     editable: false
//   },
// ]

export default {
    components:{
        VeTable,
        Spinner,
        Label,
        Spinner,
        EmptyState,
    },
    props:{
      records:{
        type: Array,
        default: () => []
      },
      cols: {
        type: Array,
        default: () => [],
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    data(){
      return {
        sortConfig: {},
        sortOption: {
            sortAlways: true,
            sortIcons: {
                ascend: "top-arrow",
                descend: "bottom-arrow"
            },
            sortChange: params => {
                this.sortConfig = params
                this.$emit('on-sort-change', params)
            },
        },
      }
    },
    computed:{
      ...mapGetters({
          meta: "tools/getMeta",
        }),
        showEmptyResult(){
            return this.tableData.length === 0;
        },
        tableData(){
          // return [...systemDemoData,...this.records]
          return this.records;
        },
        columns(){
            let matches = {};
            matches.name = {
                field: 'name',
                key: 'name',
                title: 'Name',
                width: 180,
                align: 'left',
                ...(this.isSortable('name') && {
                    sortBy: this.sortConfig.name || '',
                }),
            };
            matches.kind = {
                field: 'kind',
                key: 'kind',
                title: 'Type',
                width: 180,
                align: 'left',
                ...(this.isSortable('kind') && {
                    sortBy: this.sortConfig.kind || '',
                }),
            };
            matches.created_at = {
                field: 'created_at',
                key: 'created_at',
                title: 'Created At',
                width: 350,
                align: 'left',
                ...(this.isSortable('created_at') && {
                    sortBy: this.sortConfig.created_at || '',
                }),
                renderBodyCell:({row})=>{
                  const time = moment(row.created_at).format("Do MMM, YYYY h:mm A");
                  return time;
                },
            };
            matches.description = {
                field: 'description',
                key: 'description',
                title: 'Description',
                width: 350,
                align: 'left',
                ...(this.isSortable('description') && {
                    sortBy: this.sortConfig.description || '',
                }),
            };
            matches.action = {
                field: 'action',
                key: 'action',
                title: this.$t('COUPON.COUPON_LIST.TABLE_HEADER.ACTION'),
                align: 'center',
                width: 200,
                // fixed: this.isMobile ? false:'right',
                renderBodyCell: ({row}) => {
                    // <WootButton
                    //     variant="clear"
                    //     icon="edit"
                    //     color-scheme="secondary"
                    //     classNames="Xgrey-btn"
                    //     onClick={() => this.$emit('on-edit-click', row)}
                    //     >
                    //     </WootButton>
                    //     <WootButton
                    //     variant="link"
                    //     icon="dismiss-circle"
                    //     color-scheme="secondary"
                    //     onClick={() => this.$emit('on-delete-click', row)}
                    //     >
                    //     </WootButton>
                    return (
                    <div class="button-wrapper">
                        <WootButton
                        variant="clear"
                        icon="copy"
                        color-scheme="secondary"
                        classNames="Xgrey-btn"
                        onClick={() => this.$emit('on-duplicate-click', row)}
                        >
                        </WootButton>
                        <WootButton
                          variant="clear"
                          icon="edit"
                          color-scheme="secondary"
                          classNames="Xgrey-btn"
                          onClick={() => this.$emit('on-edit-click', row)}
                          >
                        </WootButton>
                        {
                          !row.system_tool
                          ? <WootButton
                            variant="link"
                            icon="dismiss-circle"
                            color-scheme="secondary"
                            onClick={() => this.$emit('on-delete-click', row)}
                            >
                            </WootButton>
                          : null
                        }

                    </div>
                    )
                },
            };

            const preSet = [];
            this.cols.forEach(col=>{
                if (col.visible) {
                    if (col.key in matches) {
                    preSet.push(matches[col.key])
                    }
                }
            })
            return preSet;
        }
    },
    methods:{
        isSortable(key) {
            return Array.isArray(this.meta?.sorts) && this.meta.sorts?.includes(key);
        },
    },
}
</script>



<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.tool_name{
  cursor: pointer;
}
</style>
